import { EventoCalendario } from '../EventoCalendario';
import Processo from '../../../../model/processo/Processo';

export const converterProcessoParaEventosCalendario = (processo: Processo, corUsuario: string): EventoCalendario[] => {
    const atividades = processo.cronograma?.atividades || [];

    return atividades.map(atividade => ({
        id: atividade.id,
        title: atividade.descricao,
        start: new Date(`${atividade.data}T${atividade.hora}`),
        end: new Date(`${atividade.data}T${atividade.hora}`),
        color: corUsuario,
        descricao: atividade.descricao,
        unidade: atividade.unidade,
        lugar: atividade.lugar,
        data: atividade.data,
        hora: atividade.hora,
        cronogramaId: atividade.cronogramaId
    }));
};
